import RequestHelper from "../apis/RequestHelper";
import { getErrorCodeTranslation } from "../utils/errorCodeTranslations";
import { ToastService } from "./toast.service";

export class LoyaltyService {
  public static async registerCard(
    formValues: ILoyaltyFormValues,
    recaptchaToken: string
  ): Promise<ILoyaltyCardResponse | any> {
    const currentLanguage = localStorage.getItem("language") || "ge";

    try {
      const response = await RequestHelper.kari.post(
        "/cards/self/add",
        formValues,
        {
          headers: {
            token: recaptchaToken,
          },
        }
      );
      return response.data;
    } catch (err: any) {
      ToastService.createToast(
        getErrorCodeTranslation(err, currentLanguage),
        "error"
      );
      return err;
    }
  }

  public static async resendOtp(
    requestId: string,
    recaptchaToken: string
  ): Promise<any> {
    const currentLanguage = localStorage.getItem("language") || "ge";
    try {
      const response = await RequestHelper.kari.post(
        "/cards/self/resend/otp",
        {
          requestId,
        },
        {
          headers: {
            token: recaptchaToken,
          },
        }
      );
      return response.data;
    } catch (err: any) {
      ToastService.createToast(
        getErrorCodeTranslation(err, currentLanguage),
        "error"
      );
      return err;
    }
  }

  public static async validateOtp(
    requestId: string,
    otp: string,
    showToast: boolean,
    recaptchaToken: string
  ): Promise<any> {
    const currentLanguage = localStorage.getItem("language") || "ge";
    try {
      const response = await RequestHelper.kari.post(
        "/cards/self/validate/otp",
        {
          requestId,
          otp,
        },
        {
          headers: {
            token: recaptchaToken,
          },
        }
      );
      return response.data.data;
    } catch (err: any) {
      if (showToast) {
        ToastService.createToast(
          getErrorCodeTranslation(err, currentLanguage),
          "error"
        );
      }
      return err;
    }
  }

  public static async getBanners(): Promise<any> {
    const currentLanguage = localStorage.getItem("language") || "ge";
    try {
      const response = await RequestHelper.kari.get("/cards/banners");
      return response.data;
    } catch (err: any) {
      ToastService.createToast(
        getErrorCodeTranslation(err, currentLanguage),
        "error"
      );
      return err;
    }
  }
}
